import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web';

class WritingResponseClap
 extends React.Component {

   constructor(props) {
     super(props)

     this.state = {
       claps: '',
       clapped: '',
       lottieLoaded: false
     }

     this.onClick = this.onClick.bind(this)
     this.loadLottie = this.loadLottie.bind(this)
   }

   componentWillMount() {
     let currentUserId = this.props.currentUser.id
     this.setState({
       claps: this.props.response.claps.length + 1,
       clapped: (this.props.response.claps.some(function(i) {return i["user_id"] === currentUserId}) || this.props.response.user_id === this.props.currentUser.id)
     }, () => this.loadLottie())
   }



   componentWillUnmount() {
     this.setState({
       claps: '',
       clapped: '',
       lottieLoaded: false
     })
   }

   loadLottie() {

     if(this.state.clapped === false && this.state.lottieLoaded === false) {
       this.setState({
         lottieLoaded: true
       })

       lottie.loadAnimation({
         container: document.getElementById(`clap${this.props.response.id}`),
         renderer: 'svg',
         loop: false,
         autoplay: false,
         name: `clap${this.props.response.id}`,
         path: this.props.clapLottie
       });

     }

   }

   onClick() {
     lottie.play(`clap${this.props.response.id}`)
     this.setState({
       claps: this.state.claps+1
     })

     $.ajax({
       url: `../create_clap`,
       dataType: 'JSON',
       type: 'POST',
       header: {
         'Content-Type': 'application/json'
       },
       data: {
         writing_response_id: this.props.response.id,
       },
       success: (data) => {
         setTimeout( () => {
           this.setState({
             clapped: true
           })
         }, 500);

         return
       },
       error: function(xhr, status, err) {
         console.log(err)
       }.bind(this)
     });

   }

   render() {
     return(
       <div style={{display: 'flex', flexDirection: 'row', marginTop: -5, marginRight: -5, paddingLeft: 10, justifyContent: 'center', alignItems: 'center', height: 40, float: 'right'}}>
          <h3 style={{fontWeight: 600, color: '#03A9F4', paddingRight: 3}}>{this.state.claps}</h3>
          {this.state.clapped === true && <img src={this.props.clapIcon} style={{height: 30, width: 30}} />}
          {this.state.clapped === false && <div id={`clap${this.props.response.id}`} style={{height: 45, width: 45, marginTop: -15, marginRight: -15, cursor: 'pointer'}} onClick={() => this.onClick()}></div>}
       </div>
     )
   }

 }

 export default WritingResponseClap;
